import api from './api';
import { fetchPage } from './pagedParams';

const promotionService = {
    getPromotions: async () => (await api.get('/admin/promotions')).data,
    getPromotionById: async (id) => (await api.get(`/admin/promotions/${id}`)).data,
    createPromotion: async (data) => (await api.post('/admin/promotions', data)).data,
    updatePromotion: async (id, data) => (await api.put(`/admin/promotions/${id}`, data)).data,
    toggleActive: async (id) => (await api.patch(`/admin/promotions/${id}/toggle-active`)).data,
    deletePromotion: async (id) => (await api.delete(`/admin/promotions/${id}`)).data,
    getPromotionOrders: async (promotionId) => (await api.get(`/admin/orders/by-promotion/${promotionId}`)).data,

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getPromotionsPage: (params) => fetchPage('/admin/promotions/paged', params),

};

export default promotionService;
